<script lang="ts">
    import {languageData} from "../../Data/Layout/Header";
    import { setupI18n } from "../../i18n";
    import { currentLang, langOpen } from "../../store";
    function handleclick() {
      langOpen.update((value) => (value = !value));
    }
    let setlangOpen:boolean;
    langOpen.subscribe((value) => {
      setlangOpen = value;
    });
    $: setupI18n({ withLocale: "en" });
    const handleLangauge = (lang) => {
      setupI18n({ withLocale: lang });
      currentLang.update((value) => (value = lang));
      langOpen.update((value) => (value = false));
    };
    let setSelectLang:string
    currentLang.subscribe((value) => {
        setSelectLang = value;
    });
</script>
  
<li class="language-nav">
    <div class="translate_wrapper {setlangOpen ? 'active' : ''}" id="language">
      <div class="current_lang">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="lang d-flex" on:click={handleclick}>
          <i
            class="flag-icon flag-icon-{setSelectLang === 'en' ? 'us' : setSelectLang}"
          />
          <span class="lang-txt">{setSelectLang}</span>
        </div>
      </div>
      <div class="more_lang {setlangOpen ? 'active' : ''}" id="language">
        {#each languageData as languageItem}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div
            class="lang {languageItem.value === setSelectLang ? 'selected' : ''}"
            data-value={languageItem.value}
            on:click={() => handleLangauge(languageItem.value)}
          >
            <i class="flag-icon {languageItem.icon}" />
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="lang-txt"
              >{languageItem.langname}
              <span> {languageItem.sortname === undefined ? "" : languageItem.sortname}</span>
            </span>
          </div>
        {/each}
      </div>
    </div>
</li>
  